import { useTranslation } from 'react-i18next'

import { ArrowSquareOutIcon, DotsThreeCircleVerticalIcon, EyeIcon } from '@phosphor-icons/react'

import { ButtonMenu, IconButton } from '@reveni-io/reveni-ui'

import { openInNewTab } from '@/common/helpers/helpers'

import * as Styles from './styles'

const ParcelCardMenu = ({
  onViewParcelDetail,
  orderTrackingPageUrl,
  carrierTrackingPageUrl,
  displayCarrierTrackingPageAction,
}) => {
  const { t } = useTranslation()

  const handleOpenOrderTrackingPage = () => openInNewTab(orderTrackingPageUrl)
  const handleOpenCarrierTrackingPage = () => openInNewTab(carrierTrackingPageUrl)

  const options = [
    {
      label: (
        <Styles.MenuOptionLabel>
          <EyeIcon />
          {t('Ir al detalle del envío')}
        </Styles.MenuOptionLabel>
      ),
      onClick: onViewParcelDetail,
      disabled: false,
      visible: true,
    },
    {
      label: (
        <Styles.MenuOptionLabel>
          <ArrowSquareOutIcon />
          {t('Ir a la página de seguimiento')}
        </Styles.MenuOptionLabel>
      ),
      onClick: handleOpenOrderTrackingPage,
      disabled: false,
      visible: !!orderTrackingPageUrl,
    },
    {
      label: (
        <Styles.MenuOptionLabel>
          <ArrowSquareOutIcon />
          {t('Ir a la página de seguimiento del transportista')}
        </Styles.MenuOptionLabel>
      ),
      onClick: handleOpenCarrierTrackingPage,
      disabled: false,
      visible: !!displayCarrierTrackingPageAction && !!carrierTrackingPageUrl,
    },
  ]

  return (
    <ButtonMenu
      menuItems={options.filter(option => option.visible)}
      renderButton={onOpen => (
        <IconButton
          onClick={onOpen}
          variant="text"
          icon={<DotsThreeCircleVerticalIcon data-testid="parcelCardMenuButton" size={16} />}
        />
      )}
    />
  )
}

export default ParcelCardMenu
